import { Button } from "@admin/components/atoms/Button";
import { Modal, ModalProps } from "@admin/components/atoms/Modal";
import { deleteMultipleShifts, Shift } from "@enos-monorepo/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

interface DeleteTodaysAllOpenShiftsModalProps extends ModalProps {
  shifts: Shift[];
}
export function DeleteTodaysAllOpenShiftsModal({
  shifts,
  ...props
}: DeleteTodaysAllOpenShiftsModalProps) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: deleteMultipleShifts,
    onSuccess: () => {
      toast.success(t("shift.The shift has been deleted"));
      queryClient.invalidateQueries({ queryKey: ["shifts"] });
      props.onClose?.();
    },
    onError: () => {
      toast.error(t("shift.Unable to delete the shift"));
    },
  });

  const onSubmit = () => {
    const payload = shifts.map((shift) => shift.id) as string[];
    deleteMutation.mutate(payload);
  };

  return (
    <Modal
      title={t("shift.Delete All Open Shifts")}
      {...props}
      actionButtons={
        <>
          <Button variant="secondary" type="button" onClick={props?.onClose}>
            {t("common.Discard")}
          </Button>
          <Button
            variant="primary"
            type="submit"
            disabled={deleteMutation.isPending}
            loading={deleteMutation.isPending}
            onClick={onSubmit}
          >
            {t("shift.Delete All Open Shifts")}
          </Button>
        </>
      }
    >
      <form>
        {t(
          "shift.You are about to delete all the open shifts for today. Are you sure?",
        )}
      </form>
    </Modal>
  );
}
